import loadable from '@loadable/component';
import loadableModule from '../../loadable-module';

const ReviewsModule = loadableModule({
    LoadableComponent: loadable(() =>
        import(
            /* webpackChunkName: "unit-reviews" */
            './Reviews'
        )
    ),
    componentName: 'Reviews',
    placeholder: {
        cardType: 'CardType3',
        placeholderType: 'Carousel',
        size: 'lg',
    },
});

export default ReviewsModule;
